<template>
  <div class="agreements">
    <iframe :src="url + '/users/agreements/license'" frameborder="0" style="width: 100%; height: 99%"></iframe>
  </div>
</template>

<script>
export default {
  name: "Agreements", 
  data() {
    return {
      url: process.env.VUE_APP_API_URL
    }
  },
}
</script>

<style>
.agreements {
  height: 100%;
  margin-top: 30px;
  margin-left: 30px;
}
</style>